import React, {Component} from 'react';

class ConfirmPlotsStatus extends Component {
    render() {
        return (
            <div>
                
            </div>
        );
    }
}

export default ConfirmPlotsStatus;
